/**
 * SchemaTab — Column list with types, null rates, PII/PK/FK flags.
 * Compact row height (36px). Expandable for large tables.
 */

import type { ColumnDetail } from "./DetailPanel";

interface SchemaTabProps {
  columns: ColumnDetail[];
}

export function SchemaTab({ columns }: SchemaTabProps) {
  if (columns.length === 0) {
    return (
      <p className="text-caption text-[var(--muted-foreground)]">
        No schema data available yet.
      </p>
    );
  }

  return (
    <div className="space-y-1">
      {/* Header */}
      <div className="flex items-center gap-3 px-2 py-1 text-caption font-medium text-[var(--muted-foreground)] border-b border-[var(--border)]">
        <span className="flex-1">Column</span>
        <span className="w-20 text-right">Type</span>
        <span className="w-16 text-right">Null %</span>
        <span className="w-16 text-right">Flags</span>
      </div>

      {/* Rows */}
      {columns.map((col) => (
        <div
          key={col.name}
          className="flex items-center gap-3 px-2 h-9 text-caption hover:bg-white/5 rounded-md transition-colors"
        >
          <span className="flex-1 truncate text-[var(--foreground)]">
            {col.name}
          </span>
          <span className="w-20 text-right text-[var(--muted-foreground)]">
            {col.dtype}
          </span>
          <span className="w-16 text-right text-[var(--muted-foreground)]">
            {col.nullRate.toFixed(1)}%
          </span>
          <span className="w-16 text-right flex justify-end gap-1">
            {col.isPK && (
              <span className="px-1 rounded bg-[var(--primary)]/20 text-[var(--primary)]">
                PK
              </span>
            )}
            {col.isFK && (
              <span className="px-1 rounded bg-[var(--info)]/20 text-[var(--info)]">
                FK
              </span>
            )}
            {col.isPII && (
              <span className="px-1 rounded bg-[var(--warning)]/20 text-[var(--warning)]">
                PII
              </span>
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
